import { createMiddleware } from '@tanstack/react-start';

import { serverEnv } from '@/env';

export const setupMiddleware = createMiddleware().server(async ({ next }) => {
  const backendBaseUrl = serverEnv.TESSERA_BACKEND_URL;

  return next({ context: { backendBaseUrl } });
});
